// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1UZsD","addWidgetButton":"Header_addWidgetButton__1sckK","dashboardTabs":"Header_dashboardTabs__hjXQz","active":"Header_active__1vKcu"};